export default __webpack_public_path__ + "static/outreach-services-centralized-monitoring-f644e8f977d94f17a912a5ebf768d873.jpg";